const state_ = () => ({
    items: false,
    pages: false,
    meta: false,
    current: false,
    currentId: false,
    item: false,
});


const getters_ = {
    pages(state) {
        return state.pages
    },
    meta(state) {
        return state.meta
    },
    item(state) {
        return state.item
    },
    items(state) {
        return state.items
    },
    currentId(state) {
        return state.currentId
    },
    current(state) {
        return state.current
    },
}

const actions_ = {
    async get_count(ctx, data = {}) {
        data.get_count = 'Y'
        let result = await this.$api.stuffing.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        return answer
    },
    async list({commit}, data) {
        let result = await this.$api.stuffing.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItems', answer)
        commit('setPages', result.meta.links)
        commit('setMeta', result.meta)
        return answer
    },
    async detail({commit}, data) {
        let result = await this.$api.stuffing.detail(data.code, data)
        if (!result || typeof result.data == 'undefined') {
            const answer = {
                id: 'add',
                name: '',
                text: '',
            }
            commit('setItem', answer)
            return false;
        }
        const answer = result.data;
        // answer.comment = 'setItem';
        commit('setItem', answer)
        return answer
    },
    async add({commit}, data) {
        data.is_active = data.is_active ? 1 : 0;
        let result = await this.$api.stuffing.add(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItem', answer)
        return answer
    },
    async update({commit, dispatch}, data) {
        if (data.id == 'add') {
            return await dispatch('add', data)
        }
        let result = await this.$api.stuffing.update(data.id, data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItem', answer)
        return answer
    },
};

const mutations_ = {
    setItem(state, item) {
        for (var i in item) {
            item[i] = item[i] === null ? '' : item[i];
        }
        item.is_active = item.is_active == 1;
        state.item = item;
    },
    setItems(state, items) {
        for (var i in items) {
            items[i].is_active = !!items[i].is_active;
        }
        state.items = items;
    },
    setPages(state, data) {
        var pages = data;
        var links = {
            prev: pages.shift(),
            next: pages.pop(),
        };
        state.pages = {
            items: pages,
            links: links,
        }
    },
    setMeta(state, data) {
        state.meta = data
    },
};
export const actions = actions_;
export const state = state_;
export const mutations = mutations_;
export const getters = getters_;
